import { applyParentReferences } from '../ContentNode/ContentNode.utils';
import { runtimeOperationTypes } from './runtime-operation-types';
export const createRuntimeOperationType = (operationType) => {
    return operationType;
};
export const executeRuntimeOperation = (operationConfig, context) => {
    const operation = runtimeOperationTypes[operationConfig.kind];
    if (!operation) {
        throw new Error(`Unknown operation: ${String(operationConfig.kind)}`);
    }
    return operation.run(operationConfig.value, context, runtimeOperationTypes);
};
const runtimeOperationTypeKeys = Object.keys(runtimeOperationTypes);
export const isRuntimeOperationConfig = (value) => {
    return (isRecord(value) &&
        'kind' in value &&
        runtimeOperationTypeKeys.includes(value.kind));
};
export const extractValueFromContext = (selector, context) => {
    if (selector.length === 0)
        return context;
    const [key, ...rest] = selector;
    if (Array.isArray(context)) {
        return extractValueFromContext(selector, context[0]);
    }
    if (typeof context === 'function') {
        return extractValueFromContext(selector, context());
    }
    if (typeof context === 'object' && context !== null) {
        return extractValueFromContext(rest, context[key]);
    }
    return undefined;
};
export const mapRecord = (record, fn) => Object.fromEntries(Object.entries(record).map(([key, value]) => [
    key,
    fn(key, value, record),
]));
export const isRecord = (value) => {
    return typeof value === 'object' && value !== null;
};
export const isDataTypeConfig = (value) => {
    return (isRecord(value) &&
        'kind' in value &&
        'state' in value &&
        'typeName' in value);
};
export const containsRuntimeOperationConfig = (value) => {
    if (Array.isArray(value)) {
        return value.some(containsRuntimeOperationConfig);
    }
    if (isRuntimeOperationConfig(value)) {
        return true;
    }
    if (typeof value === 'object' && value !== null) {
        return Object.entries(value).some(([key, value]) => {
            if (typeof value === 'object' &&
                value !== null &&
                'kind' in value &&
                key === 'parent') {
                return false;
            }
            return containsRuntimeOperationConfig(value);
        });
    }
    return false;
};
export const applyTHISContext = () => (options) => {
    return {
        ...options,
        context: {
            ...options.context,
            THIS: options.contentNode,
        },
    };
};
export const isKind = (kind) => (node) => {
    return node.kind === kind;
};
export const getContentNode = () => (options) => {
    return options.contentNode;
};
export const updateParentRefs = () => (options) => {
    return Object.assign({}, options, {
        contentNode: applyParentReferences(options.contentNode),
    });
};
export const addDefaultContext = () => (options) => {
    if (options.context)
        return options;
    return {
        ...options,
        context: {
            ...options.context,
        },
    };
};
//# sourceMappingURL=runtime-processing.parts.js.map